// Runs of loaded frames as [start, end] fractions of the line, each frame spanning half a
// step either side of its position so the runs line up with the playhead.
export function getBufferedRanges(loaded: boolean[]): [number, number][] {
  const n = loaded.length;
  if (n === 1) {
    return loaded[0] ? [[0, 1]] : [];
  }
  const ranges: [number, number][] = [];
  let runStart: number | null = null;
  loaded.forEach((isLoaded, i) => {
    if (isLoaded && runStart === null) {
      runStart = i;
    }
    if (runStart !== null && (!isLoaded || i === n - 1)) {
      const runEnd = isLoaded ? i : i - 1;
      ranges.push([Math.max((runStart - 0.5) / (n - 1), 0), Math.min((runEnd + 0.5) / (n - 1), 1)]);
      runStart = null;
    }
  });
  return ranges;
}
